export const DEFAULT_PLAN_VARIANT_ID = "3215";
export const DEFAULT_PLAN_AMOUNT = "699";
export const DEFAULT_PLAN_NAME = "Protect";
export const DEFAULT_COVERAGE_AMOUNT = "5,000";
export const PROTECT_PLUS_COVERAGE_AMOUNT = "10,000";
export const PLAN_DURATION = "1 Year";
export const COUNTRY = "India";
